/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('CurrentActivitiesCtrl', function(
    $filter,
    $scope,
    $routeParams,
    $timeout,
    Term,
    CurrentActivities,
    modules_url,
    ErrorThrower
) {
    const errorManager           = new ErrorThrower;
    $scope.modules_url     = modules_url;
    $scope.show_activities = true;
    $scope.display_course  = true;

    $scope.display_activities = () => $scope.show_activities = !$scope.show_activities;

    $scope.show_courses = () => $scope.display_course = !$scope.display_course;

    $scope.dateDiff = function(date, reference) {
        if (reference == null) { reference = moment(); }
        if (date == null) { return -1; }

        // On créé une copie de travail
        date = angular.copy(date);
        date = moment(date);

        switch (false) {
            case !date.isBefore(reference): return -1;
            case !date.isAfter(reference): return 1;
            default: return 0;
        }
    };

    $scope.login = $routeParams.login;

    $scope.getTimestamp = timestamp => moment(timestamp).format('X');

    Term
    .query({
        login: $routeParams.login})
    .$promise
    .then(terms => $scope.terms = terms).catch(api_error => errorManager.minor(api_error.statusText));

    CurrentActivities
    .query({
        login: $routeParams.login})
    .$promise
    .then(function(activities) {
        activities               = activities.toJSON();
        $scope.activities_name   = Object.keys(activities);
        $scope.activities_length = Object.keys(activities).length;

        // ici on parcourt les activities jusqu'à arriver dans les steps des Quests
        for (let name in activities) {
            const module = activities[name];
            for (let activity of Array.from(module.quest)) {
                activity.current_steps = activity.stages != null ? activity.stages.filter(function(step) {
                    step.icon = 'fa fa-circle-o fa-lg text-muted';
                    if (step.validation != null) {
                        switch (step.validation.validation) {
                            case 'request':
                                step.icon = 'fa fa-clock-o fa-lg text-warning';
                                break;
                            case 'denied':
                                step.icon = 'fa fa-times-circle-o fa-lg text-danger';
                                break;
                            case 'valid':
                                step.icon = 'fa fa-check-circle-o fa-lg text-success';
                                break;
                        }
                    }

                    return moment(step.end).isAfter();
                }) : undefined;
            }
        }

        return $scope.activities = activities;
    });

    $scope.warnDeadline = function(event_date) {
        if (event_date == null) { return; }

        const one_week     = moment().add(1, 'w');
        const one_day      = moment().add(1, 'd');
        const event_moment = moment(event_date);

        switch (false) {
            case !event_moment.isBefore(one_week): return 'panel-warning';
            case !event_moment.isBefore(one_day):  return 'panel-danger';
            default: return 'panel-default';
        }
    };

    return $scope.stepTimeDisplay = function(step) {
        if (step == null) { return; }

        const step_start = moment(step.start);
        const step_end   = moment(step.end);
        if (step_start.isBefore() && step_end.isAfter()) {
            const displayed_end = $filter('humanize')(step_end);
            return `fin ${displayed_end}`;
        } else if (step_start.isAfter()) {
            const displayed_start = $filter('humanize')(step_start);
            return `débute ${displayed_start}`;
        }
    };
});
